module.exports = __webpack_public_path__ + "static/media/favebiz-marketing.9616fca1.jpg";